import { PARTNER_INFO_LOADED } from 'src/constants/partnerMemberships';

export const partnerInfoLoaded = ({ key, data }) => ({
  type: PARTNER_INFO_LOADED,
  key,
  data,
});
